const O = "#F7791E";
const K = "#0D0D0D";

export const QMark = ({ className = "h-9 w-9", ...rest }) => (
  <svg viewBox="0 0 1024 1024" className={className} role="img" aria-label="The Queue Q logo" {...rest}>
    <circle cx="512" cy="512" r="357" fill={O} />
    <polygon points="795,730 852,788 773,867 713,808" fill={O} />
    <path fillRule="evenodd" fill={K} d="M304 500a208 208 0 1 0 416 0a208 208 0 1 0 -416 0Z M392 500a120 120 0 1 0 240 0a120 120 0 1 0 -240 0Z" />
    <polygon points="640,590 724,670 668,726 584,646" fill={K} />
    <clipPath id="qmark-door"><circle cx="512" cy="500" r="120" /></clipPath>
    <g clipPath="url(#qmark-door)">
    <rect x="455" y="410" width="125" height="8" fill={K} />
    <rect x="572" y="410" width="8" height="190" fill={K} />
    <polygon points="455,409 545,436 545,444 455,417" fill={K} />
    <polygon points="442,594 545,632 545,640 442,602" fill={K} />
    <rect x="540" y="436" width="10" height="204" fill={K} />
    <path d="M500 530 L520 524 A6 6 0 1 1 520 536 Z" fill={K} />
    </g>
  </svg>
);

export const PoweredBy = ({ logo, name = "The Queue" }) => (
  <div className="flex items-center gap-4" data-testid="footer-powered-by">
    <span className="text-xs text-zinc-500">Powered by</span>
    <div className="flex min-w-[96px] flex-col items-center gap-1 text-center">
      {logo ? (
        <img src={logo.url} alt={name} className="h-[60px] w-auto max-w-[160px] object-contain" data-testid="footer-powered-by-logo" />
      ) : (
        <>
          <QMark className="h-9 w-9" data-testid="powered-by-q-icon" />
          <span className="text-sm font-bold leading-none text-white" data-testid="powered-by-name">{name}</span>
          <span className="text-[9px] uppercase leading-none tracking-[0.25em] text-[#F7791E]/80" data-testid="powered-by-tagline">
            Software for you
          </span>
        </>
      )}
    </div>
  </div>
);
